import React from "react";
import "../pages/paymentPage.css";
import { Grid } from "@mui/material";

const Whatnext = ({ steperData }) => {
  return (
    <div style={{ paddingTop: '10px' }}>
      <Grid container style={{ backgroundColor: "#e0e0e0", padding: '15px 0px 15px 10px' }}>
        {steperData && steperData.map((val) => (
          <Grid item xs={12} sm={val.width || 4} key={val.step}>
            <div style={{ display: "flex" }}>
              <div className="step-number">{val.step}</div>
              <div className="step-text">{val.title}</div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Whatnext;
